import Repository from "./Repository";

const formDataConfig = {
  headers: { "Content-Type": "multipart/form-data" },
};

const getAll = "/marcom/admin/dbSync";
const updateUser = "/marcom/admin/update";
const createSegmentType = "/marcom/segment/segmentType";
const createSegment = "/marcom/segment/create";
const getAllSegmentTypes = "/marcom/segment/getAllSegmentType";
const getAllSegment = "/marcom/segment/getAll";
const addMember = "/marcom/audience/addAudience";
const deleteAudience = "marcom/audience/delete";
const updateAudience = "/marcom/audience/update";

export default {
  GetAllUsers(payload) {
    return Repository.post(`${getAll}`, payload);
  },
  updateUser(payload) {
    return Repository.post(`${updateUser}`, payload);
  },
  createSegmentTypes(payload) {
    return Repository.post(`${createSegmentType}`, payload);
  },
  createSegment(payload) {
    return Repository.post(`${createSegment}`, payload);
  },
  getAllSegmentType(payload) {
    return Repository.post(`${getAllSegmentTypes}`, payload);
  },
  getAllSegment(payload) {
    return Repository.post(`${getAllSegment}`, payload);
  },
  addAudience(payload) {
    return Repository.post(`${addMember}`, payload);
  },
  deleteAudience(payload) {
    return Repository.post(`${deleteAudience}`, payload);
  },
  updateAudience(payload) {
    return Repository.post(`${updateAudience}`, payload);
  },
};
